const fetch = require('node-fetch')

module.exports = async function chronosFetch (url) {
  return fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Basic ${process.env.GATSBY_CHRONO_AUTH_TOKEN}`,
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: new URLSearchParams({
      grant_type: 'client_credentials',
      scope: 'verification/verification-create leads/lead-create verification/verification-read leads/simulation-read'
    })
  }).then(async (res) => res.json()).then(res => res)
}
